import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared/shared.module';
import { ManagerComponentsModule } from '../../components/manager-components.module';
import { ApiDocumentationComponent } from './api-documentation.component';

@NgModule({
	imports: [SharedModule, ManagerComponentsModule],
	exports: [],
	declarations: [ApiDocumentationComponent],
	providers: []
})
export class ApiDocumentationModule {}
